import { useEffect, useState } from 'react'
import { consumirApi } from '../../utils/consumoApi'
import { API_BASE_URL } from '../../utils/config.js' 
import { agregarDatosEmpresaUsuario } from '../../utils/empresaUsuario'
import ErrorAlert from '../../components/common/ErrorAlert'
import Table from '../../components/tables/TableFilter'
import Button from '../../components/common/Button'
import Modal from '../../components/modals/Modal'
import ModalConfirmacion from '../../components/modals/ModalConfirmacion'
import Form from '../../components/forms/Form'
import Input from '../../components/common/Input'
import Notification from '../../components/common/Notification'
import Spinner from '../../components/common/Spinner'
import { FaFileExcel  } from "react-icons/fa"

const Acciones = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    // campos  
    const [idAccion, setIdAccion] = useState("")
    const [accion, setAccion] = useState("")
    const [costoBase, setCostoBase] = useState("")
    const [sujetoMetraje, setSujetoMetraje] = useState("")
    const [sujetoUbicacion, setSujetoUbicacion] = useState("")
    const [unidad, setUnidad] = useState("")
    const [descripcion, setDescripcion] = useState("")
    // modales
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
    // notificaciones y cargas
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)
    //seleccion de fila
    const [selectedId, setSelectedId] = useState(null)
    //datos para la tabla
    const columnas = [
        { titulo: 'Accion', campo: 'accion' },
        { titulo: 'Costo base', campo: 'costo_base' },
        { titulo: 'Sujeto a metraje', campo: 'sujeto_metraje' },
        { titulo: 'Sujeto a ubicación', campo: 'sujeto_ubicacion' },
        { titulo: 'Unidad de medida', campo: 'unidad' },
    ]

    // Carga inicial de las acciones
    useEffect(() => { obtenerAcciones() }, [])

    // Funcion para obtener las acciones
    const obtenerAcciones = async () => {
        const respuesta = await consumirApi('GET', `maestros/accion/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    // Funcion para registrar una nueva accion
    const registrarAccion = (async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/accion`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Acción registrada correctamente" })
            limpiarCampos()
            obtenerAcciones()
        }
        else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    })

    // Edición  accion
    const enviarEdicionAccion = async (e) => {
        e.preventDefault()
        const data = { accion, costo_base: costoBase, sujeto_metraje: sujetoMetraje, sujeto_ubicacion: sujetoUbicacion, unidad, descripcion }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/accion/${idAccion}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Acción actualizada correctamente" })
            limpiarCampos()
            obtenerAcciones()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    const abrirModalEditar = (datos) => {
        setIdAccion(datos.id)
        setAccion(datos.accion)
        setCostoBase(datos.costo_base)
        setSujetoMetraje(datos.sujeto_metraje ? 1 : 0)
        setSujetoUbicacion(datos.sujeto_ubicacion ? 1 : 0)
        setUnidad(datos.unidad)
        setDescripcion(datos.descripcion)
        setMostrarModalEditar(true)
    }

    // Manejar selección de checkbox
    const seleccionAccion = (data) => {
        setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    }

    // funcion para abrir el modal para editar accion
    const eliminarAccion = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/accion/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Acción eliminada correctamente" })
            limpiarCampos()
            obtenerAcciones()
        } else {
            setError(respuesta.error)
        }
    }

    const limpiarCampos = () => {
        setSelectedId(null)
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEliminar(false)
        setError('')
        setAccion('')
        setCostoBase('')
        setUnidad('')
        setDescripcion('')
        setSujetoMetraje(0)
        setSujetoUbicacion(0)
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className="w-full min-h-[calc(100vh-50px)] overflow-y-auto">
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
            <Button className="ml-3 mt-2"  type="delete" disabled={!selectedId} onClick={()=> setMostrarModalEliminar(true)} />
            <FaFileExcel size={30} color="green" className="ml-3 mt-0 inline cursor-pointer" onClick={() => window.open(`${API_BASE_URL}/export/acciones/${idEmpresa}`, "_blank")} />
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5 mt-2">No se encontraron acciones</div>
                ) : (
                    <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
                        mostrarChecks={true}
                        seleccionFila={seleccionAccion} // Manejar el ID seleccionado
                        selectedId={selectedId} // Manejar el ID seleccionado
                    />
                )
            )}

            {/* Modal Registrar nuevo acción*/}
            <Modal isOpen={mostrarModal} title="Registrar nueva acción" onClose={limpiarCampos} >
                <Form onSubmit={registrarAccion} isSubmitting={isSubmitting}>
                    <Input name="accion" value={accion} label="Accion" type="textarea" rows="2" onChange={setAccion} />
                    <div className='flex justify-between gap-3'>
                        <Input name="costo_base" value={costoBase} type="number" label="Costo base" onChange={setCostoBase} />
                        <Input type="select" name="unidad" value={unidad} label="Unidad de medida" onChange={setUnidad}
                            options={[
                                { value: "M2", label: "M2" },
                                { value: "UND", label: "UND" }
                            ]}
                        />
                    </div>
                    <div className='flex justify-between'>
                        <Input type="select" name="sujeto_metraje" value={sujetoMetraje} label="Sujeto a metraje" onChange={setSujetoMetraje}
                            options={[
                                { value: "0", label: "No" },
                                { value: "1", label: "Sí" }
                            ]}
                        />
                        <Input type="select" name="sujeto_ubicacion" value={sujetoUbicacion} label="Sujeto a ubicacion" onChange={setSujetoUbicacion}
                            options={[
                                { value: "0", label: "No" },
                                { value: "1", label: "Sí" }
                            ]}
                        />
                    </div>
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal Actuazliar accion */}
            <Modal isOpen={mostrarModalEditar} title="Actualizar Acción" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionAccion}  isSubmitting={isSubmitting} type='update'>
                    <Input name="accion" value={accion} label="Accion" type="textarea" rows="2" onChange={setAccion} />
                    <Input name="Costo base" value={costoBase} label="Costo base" type="number" onChange={setCostoBase} />
                    <Input type="select" name="sujeto_metraje" value={sujetoMetraje} label="Sujeto a metraje" onChange={setSujetoMetraje}
                        options={[
                            { value: "0", label: "No" },
                            { value: "1", label: "Sí" }
                        ]}
                    />
                    <Input type="select" name="sujeto_ubicacion" value={sujetoUbicacion} label="Sujeto a ubicacion" onChange={setSujetoUbicacion}
                        options={[
                            { value: "0", label: "No" },
                            { value: "1", label: "Sí" }
                        ]}
                    />

                    <Input type="select" name="unidad" value={unidad} label="Unidad de medida" onChange={setUnidad}
                        options={[
                            { value: "M2", label: "M2" },
                            { value: "UND", label: "UND" }
                        ]}
                    />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un accion*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarAccion}
                mensaje="¿Estás seguro de que deseas eliminar la acción?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>
        </div>
    )
}

export default Acciones
